import { ethers as o } from "ethers";
import { ERC20ContractAbi as n } from "@deorderbook/contracts/abi";
import { USDCAddress as e } from "@deorderbook/contracts";
import { signer as c, provider as s } from "./provider.mjs";
const i = () => new o.Contract(e, n), p = (t = !1) => {
  const r = i();
  return t ? r.connect(c) : r.connect(s);
};
export {
  i as initUSDCContract,
  p as useUSDCContract
};
//# sourceMappingURL=usdcContract.mjs.map
